import "./MiniClaimSummary.css";
import { getLastNPathSegments, determineClaimTypes} from "../utils/utils";
import { formatDecimal } from "../../../components/dms_common/DmsUtils";

interface MiniClaimSummaryProps {
  rows?: Array<any>;
}

const parseNumber = (value: any): number => {
  if (value == null) return 0;
  const num = Number(String(value).replace(/[^\d.-]/g, ""));
  return isNaN(num) ? 0 : num;
};

const formatAmountInK = (amount: number): string => {
  if (amount >= 1000) {
    const formatted = formatDecimal(amount / 1000).replace(/\.00$/, "");
    return `${formatted}K`;
  } else {
    return formatDecimal(amount);
  }
};

const MiniClaimSummary = ({ rows = [] }: MiniClaimSummaryProps) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { caseUnitLabel, otherUnitLabel, packUnitLabel, currency, claimTypes, claimSubTypes } = ConfigDictionary;
  const path = getLastNPathSegments(window.location.href, 2);
  const secondLastSegment = path[1];
  const lastSegment = path[0];
  const { claimType } = determineClaimTypes(lastSegment, claimTypes, claimSubTypes);

  const totalCasesPiecesOthers = rows.reduce(
    (acc, row) => {
      let cases = 0;
      let pieces = 0;
      let others = 0;

      if (row.totalDamagedCs != null || row.totalDamagedPc != null || row.totalDamagedOther != null) {
        cases = parseNumber(row.totalDamagedCs);
        pieces = parseNumber(row.totalDamagedPc);
        others = parseNumber(row.totalDamagedOther);
      } else if (row.cases != null || row.pieces != null || row.others != null) {
        cases = parseNumber(row.cases);
        pieces = parseNumber(row.pieces);
        others = parseNumber(row.others);
      } else if (row.initialCases != null || row.initialPieces != null || row.initialOthers != null) {
        cases = parseNumber(row.initialCases);
        pieces = parseNumber(row.initialPieces);
        others = parseNumber(row.initialOthers);
      }

      acc.cases += cases;
      acc.pieces += pieces;
      acc.others += others;
      return acc;
    },
    { cases: 0, pieces: 0, others: 0 }
  );

  const finalClaimAmount = rows.reduce((acc, row) => {
    let amount = 0;

    if (row.discount != null) {
      amount = parseNumber(row.discount);
    } else if (row.totalClaimAmount != null) {
      amount = parseNumber(row.totalClaimAmount);
    } else if (row.claimAmount != null) {
      amount = parseNumber(row.claimAmount);
    }

    return acc + amount;
  }, 0);

  const isClaimTypeOthers = claimType === claimTypes[2];

return (
    <div className="miniClaimSummary">
      <div className="miniClaimSummary-1 miniClaimSummary-common">
        <span>Claims Summary</span>
      </div>

      {!isClaimTypeOthers && (
        <div className="miniClaimSummary-2 miniClaimSummary-common">
          {(lastSegment==="status" || secondLastSegment==="status" || secondLastSegment==="claimsStatus") ? (
            <div className="totalClaims">
              <p>{rows.length}</p>
              <span className="totalClaimQuantity">Total Claims</span>
            </div>
          ) : (
            <div className="csPcOthers">
              {caseUnitLabel && (
              <p>
                {totalCasesPiecesOthers.cases} <span>{caseUnitLabel}</span>
              </p> )}
              {otherUnitLabel && (
              <p>
                {totalCasesPiecesOthers.others} <span>{otherUnitLabel}</span>
              </p> )}
              {packUnitLabel && (
              <p>
                {totalCasesPiecesOthers.pieces} <span>{packUnitLabel}</span>
              </p> )}
              <span className="totalClaimQuantity">Total Claim Quantity</span>
            </div>
          )}
        </div>
      )}
      <div className="miniClaimSummary-3 miniClaimSummary-common">
        <span>{currency}{formatAmountInK(finalClaimAmount)}</span>
        <span className="finalClaimAmount">Final Claim Amount</span>
      </div>
    </div>
  );
};

export default MiniClaimSummary;